export const baseAnimationDuration = 1000;
export const tabletSize = 1224;
export const mobileSize = 900;
export const mediaQuery = `(min-width: ${tabletSize}px)`;
export const removeOnMobile = `(min-width: ${mobileSize}px)`;
export const addOnMobile = `(max-width: ${mobileSize - 1}px)`;
//x:1365, y:768, width:2730, height:1536
export const hotspotTransform = {
    transformTop: function(x) {
        return (1-(x+768)/1536)*100;
    },
    transformLeft: function(x) {
        return ((x+1365)/2730)*100;
    }
};